module.exports = __webpack_public_path__ + "static/media/label-icon.61ea1a28.png";